

import React, { memo, useState, useCallback } from 'react';
import { withSize } from 'react-sizeme';
import cx from 'classnames';
import { Text, Checkbox, Dropdown, Icon, Link } from '../../../../../../ui-kit';
import EditCost from '../../common/EditCost';
import MultipleDropdown from '../../common/MultipleDropdown';
import { getSelectedLabel, handleCostChange } from '../../utils';
import { getAddonTotalCost, getCostRange } from '../../../../utils';
import { MULTI, SINGLE } from '../../../../constants/dropdownTypes';
import { SMALL_SIZE, VIDEO_REVIEW } from '../../constants';

import { ABOUT_ADDON_OPTIONS } from '../../../../../../common/constants/aboutAddonOptions';
import AboutAddonModal from '../../../../AboutAddonModal';
import { withFlagsConsumer } from '../../../../../FeatureFlags';

import '../../styles/_expandable-addon.scss';
import '../../styles/_dropdown-addon.scss';





























function toggleAddonEnabled({
  selected,
  setSelected,
  onChangeAddon,
  setAddonTotalCost,
  setSelectedValue,
  onChangeSelectedCaption







}) {
  return () => {
    const newSelected = !selected;
    setSelected(newSelected);
    onChangeSelectedCaption(newSelected);

    if (newSelected) return;

    setAddonTotalCost(0);
    setSelectedValue(null);
    onChangeAddon(null);
  };
}

function onChangeAddonValue(
newValue,
selectedValue,
onChangeAddon,
setAddonTotalCost,
setSelectedValue)
{
  const totalCost = getAddonTotalCost({ selectedValue: newValue });
  const optionsWithCreatedAtParam = selectedValue && selectedValue.length ?
  selectedValue.filter(({ createdAt }) => createdAt) :
  [];
  const createdAtParam = optionsWithCreatedAtParam.length ?
  optionsWithCreatedAtParam[0].createdAt :
  new Date().toISOString();
  const valueWithCreatedAtParam = newValue.map((option) => ({
    ...option,
    createdAt: createdAtParam
  }));

  setAddonTotalCost(totalCost);
  setSelectedValue(valueWithCreatedAtParam);
  onChangeAddon(valueWithCreatedAtParam);
}

function MultiValueAddon({
  name,
  title,
  subtitle,
  options,
  onChangeAddon,
  viewMode,
  addonValue,
  icon,
  disabled,
  costPreffix,
  size: { width },
  withInfo = false,
  onInfoClick,
  getCurrencySymbol,
  getBillingEntityCode,
  onCheckboxStateChange,
  placeholder = 'Select language',
  editingMode = false,
  addItemLabel,
  dropdownType,
  showAboutInfo,
  hideCheckbox
}) {
  const [selectedValue, setSelectedValue] = useState(addonValue);
  const [selected, setSelected] = useState(Boolean(addonValue) || hideCheckbox);
  const [addonTotalCost, setAddonTotalCost] = useState(
    getAddonTotalCost({ selectedValue })
  );
  const [showAboutModal, setShowAboutModal] = useState(false);

  const onToggleAboutModal = useCallback(
    () => setShowAboutModal(!showAboutModal),
    [showAboutModal]
  );

  const selectedNumber = selectedValue && selectedValue.length;
  const isShowMultiItemsValue = dropdownType === SINGLE && Boolean(selectedNumber);

  const numberCostValue = (caption) => caption.cost ? parseInt(caption.cost.match(/\d+/g)[0], 10) : 0;

  const captionsPrice = selectedValue && Array.isArray(selectedValue) ?
  selectedValue.reduce(
    (accumulator, cost) => numberCostValue(cost) + accumulator,
    0
  ) :
  null;

  const { minCost, maxCost, currencySymbol } = getCostRange(options);

  const onChangeSelectedCaption = (checkboxSelected) => {
    if (onCheckboxStateChange) {
      onCheckboxStateChange(checkboxSelected);
    }
  };

  const isMobile = width <= SMALL_SIZE;
  const isVideoReview = viewMode === VIDEO_REVIEW;

  const showAboutInformation = showAboutInfo && ABOUT_ADDON_OPTIONS[name];

  return (
    <div
      className={cx('expandable-addon', {
        'expandable-addon--small': isMobile
      })}>

      {!hideCheckbox &&
      <div className="expandable-addon__wrapper">
          <div className="expandable-addon__main">
            <div>
              {!isVideoReview &&
            <>
                  <div className="expandable-addon__col">
                    <Checkbox
                  checked={selected}
                  onChange={toggleAddonEnabled({
                    setSelected,
                    selected,
                    onChangeAddon,
                    setAddonTotalCost,
                    setSelectedValue,
                    onChangeSelectedCaption
                  })}
                  disabled={disabled}
                  className="expandable-addon__checkbox">

                      <Icon
                    className="expandable-addon__icon"
                    name={icon}
                    size={22} />


                      <Text heading5 className="expandable-addon__title">
                        {title}
                      </Text>
                    </Checkbox>
                  </div>

                  {!editingMode &&
              <div className="expandable-addon__col">
                      <Text heading5 className="expandable-addon__cost">
                        {`${costPreffix ||
                  ''} ${currencySymbol}${minCost}-${currencySymbol}${maxCost}`}
                      </Text>
                    </div>}

                  {showAboutInformation &&
              <div className="expandable-addon__col expandable-addon__col_content-right">
                      <Link
                  className="expandable-addon__about"
                  onClick={onToggleAboutModal}>

                        {ABOUT_ADDON_OPTIONS[name].LINK_TEXT}
                      </Link>
                    </div>}

                </>}

              {withInfo &&
            <Icon
              className="expandable-addon__info"
              name="info"
              size={16}
              onClick={onInfoClick} />}


            </div>

            {!isVideoReview &&
          <Text className="expandable-addon__subtitle">{subtitle}</Text>}

          </div>

          {editingMode && selected &&
        <div>
              <EditCost
            onChangeCost={(costValue) => handleCostChange({
              costValue,
              selectedValue,
              setSelectedValue,
              onChangeAddon,
              setAddonTotalCost
            })}

            addonName={name}
            cost={addonTotalCost}
            getBillingEntityCode={getBillingEntityCode}
            disabled={disabled || dropdownType === MULTI} />

            </div>}

        </div>}

      {selected &&
      <div className="expandable-addon__children">
          <div
          className={cx('expandable-addon__dropdown-container', {
            'hide-default-value': Boolean(selectedNumber)
          })}>

            {isShowMultiItemsValue &&
          <div className="dropdown-container__multi-items-value">
                <span>
                  {getSelectedLabel({
                selectedNumber,
                addonValue,
                selectedValue,
                options
              })}
                </span>

                <span>
                  {getCurrencySymbol && getCurrencySymbol()}
                  {captionsPrice}
                </span>
              </div>}

            {dropdownType === MULTI ?
          <MultipleDropdown
            defaultValues={selectedValue || [{ value: null }]}
            onChange={(newValue) => onChangeAddonValue(
              newValue,
              selectedValue,
              onChangeAddon,
              setAddonTotalCost,
              setSelectedValue
            )}

            options={options}
            addItemLabel={addItemLabel}
            disabled={disabled}
            placeholder={placeholder} /> :


          <Dropdown
            defaultValue={addonValue}
            options={options}
            onChange={(newValue) => onChangeAddonValue(
              newValue,
              selectedValue,
              onChangeAddon,
              setAddonTotalCost,
              setSelectedValue
            )}

            placeholder={placeholder}
            hideSeparators
            showSelectedSuffix={!editingMode}
            disabled={disabled}
            type="BUTTON"
            renderMenuLocally
            closeMenuOnSelect={false}
            multi />}


          </div>
        </div>}


      {showAboutInformation &&
      <AboutAddonModal
        addonType={name}
        visible={showAboutModal}
        onClose={onToggleAboutModal} />}


    </div>);

}

export default withFlagsConsumer(memo(withSize()(MultiValueAddon)));